
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import { Flex, IconButton, Stack, Text, useColorMode } from "@chakra-ui/react";
import AuthShell from "@/src/layouts/AuthShell";
import AuthContent from "@/src/components/AuthContent";
import useTranslation from "next-translate/useTranslation";
import ChooseAccountCard from "@/src/components/ChooseAccountCard";
import { AiOutlineUser, AiOutlineUserAdd } from "react-icons/ai";
import { useRouter } from "next/router";
import Logo from "@/src/components/Logo";
import CustomLink from "@/src/components/CustomLink";

const Choose = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const { colorMode } = useColorMode();
  const { redirect_url } = router.query;

  return (
    <AuthShell>
      <AuthContent
        title={t("account:choose.page.title")}
        sub_title={t("account:choose.page.sub_title")}
        desc={t("account:choose.page.description")}
      >
        <ChooseAccountCard>
          <Flex wrap={"wrap"} gap={"8px"}>
            <Text
              fontWeight={"400"}
              fontSize={"26.0149px"}
              lineHeight={"39px"}
              textAlign={"center"}
              color={colorMode === "light" ? "#232323" : "white"}
              mb={"4px"}
            >
              {t("account:choose.card.welcome_text")}
            </Text>
            <CustomLink to={"/"} alignItems={"center"}>
              <Logo width={"215px"} height={"41px"} mb={1} />
            </CustomLink>
          </Flex>
          <Stack direction={"row"} spacing={"33px"} py={8}>
            <Flex
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={"19px"}
            >
              <IconButton
                variant={"iconButton"}
                onClick={() => router.push("/account/auth/?type=manager&redirect_url="+(redirect_url!=undefined ? encodeURIComponent(redirect_url) : ''))}
                borderRadius={"20px"}
                size={"40px"}
                padding={"22px"}
                aria-label="Search database"
                icon={<AiOutlineUser size={"50px"} />}
              />
              <Text
                fontWeight={"300"}
                fontSize={"16px"}
                lineHeight={"24px"}
                textAlign={"center"}
                color={colorMode === "light" ? "inherit" : "white"}
                // mt={"19px"}
              >
                {t("account:choose.card.register_manager")}
              </Text>
            </Flex>
            <Flex
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              gap={"19px"}
              mt={"50px"}
            >
              <IconButton
                variant={"iconButton"}
                onClick={() => router.push("/account/auth/?type=collaborator&redirect_url="+encodeURIComponent(redirect_url))}
                borderRadius={"20px"}
                size={"40px"}
                color={"#00B295"}
                padding={"22px"}
                aria-label="Search database"
                icon={<AiOutlineUserAdd size={"50px"} />}
              />

              <Text
                fontWeight={"300"}
                fontSize={"16px"}
                lineHeight={"24px"}
                textAlign={"center"}
                color={colorMode === "light" ? "inherit" : "white"}
                // mt={"19px"}
              >
                {t("account:choose.card.register_collaborator")}
              </Text>
            </Flex>
          </Stack>
        </ChooseAccountCard>
      </AuthContent>
    </AuthShell>
  );
};

export default Choose;


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/account/choose',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  